import Route from '../route';
import Button from '../../js/form/button';
import { MAIN , SAVE_FOR_LATER } from './basket_types';

$(function () {
    if (Route === "save-for-later") {
        // Move item to basket from Save for Later page
        $(document).on("click", ".move-to-basket", function (e) {

            // create new button instance
            let $moveToBasketBtn = new Button(this);
            // show loading on move to basket button
            $moveToBasketBtn.showSpinner();

            let $productRow = $(this).closest(".product__row");

            axios.post('/my-basket/ajax/move-basket-item', {
                basketItemId: $(this).data("basket-item-id"),
                basketType: MAIN,
            })
                .then(function (response) {
                    if (response.data.success) {
                        let $successNotification = $(response.data.html);
                        $productRow.empty();
                        $productRow.append($successNotification);

                        // Update the basket count icon
                        let quantity = response.data.cartCount;
                        $('.basket_icon').addClass('has-products').attr('data-basket-count', quantity);
                    }

                    $moveToBasketBtn.hideSpinner();
                })
                .catch(function (error) {
                    console.log(error.response);
                    $moveToBasketBtn.hideSpinner();
                });

        });

        // Remove item from Basket page
        $(document).on("click", ".remove-item", function (e) {
            if (!$(this).hasClass("clicked")) {

                $(this).addClass("clicked");

                let $removeItem = new Button(this);
                // show loading on remove item element
                $removeItem.showSpinner();

                $.ajax({
                    url: "/my-basket/ajax/remove-product",
                    method: "POST",
                    data: {
                        basketItemId: $(this).data("basket-item-id"),
                        basketType: SAVE_FOR_LATER
                    },
                    success: function (response) {
                        if (response.success) {
                            if (response.cartCount !== undefined) {
                                if (response.cartCount > 0) {
                                    e.target.closest(".product__row").remove();
                                    $removeItem.hideSpinner();
                                } else {
                                    location.reload();
                                }
                            }
                        }
                    },
                    error: function (response) {
                        $removeItem.hideSpinner();
                    },
                });
            }
        });

        $(document).on('change', '.product__options--quantity select[name="quantity"]', function () {
            const data = {
                basketItemId: $(this).data("basket-item-id"),
                qty: $(this).val(),
                basketType: SAVE_FOR_LATER,
              };
              
              axios.post('/my-basket/ajax/update-basket-item', data)
                .then(response => {
                  if (response.data.success !== 1) {
                    console.log('Failed to update item.');
                  }
                })
                .catch(error => {
                  // Handle error
                  console.error('There was an error updating the basket item:', error);
                });
        });
    }
});